import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations, esteponaImages } from '../data/mock';

const EsteponaSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="estepona" className="py-24 lg:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl text-stone-800 mb-4">
            {t.estepona.title}
          </h2>
          <p className="text-amber-700 text-lg font-light italic mb-6">
            {t.estepona.subtitle}
          </p>
          <p className="text-stone-600 max-w-3xl mx-auto text-lg leading-relaxed">
            {t.estepona.description}
          </p>
        </div>

        {/* Image Grid - 7 images masonry layout */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {/* Row 1: Large image + 2 small */}
          <div className="col-span-2 row-span-2 relative overflow-hidden group">
            <div className="aspect-square">
              <img
                src={esteponaImages[0].url}
                alt={esteponaImages[0].alt[language]}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-4 left-4 text-white opacity-0 group-hover:opacity-100 transition-opacity">
              <p className="text-sm font-light">{esteponaImages[0].alt[language]}</p>
            </div>
          </div>

          <div className="relative overflow-hidden group">
            <div className="aspect-square">
              <img
                src={esteponaImages[1].url}
                alt={esteponaImages[1].alt[language]}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>

          <div className="relative overflow-hidden group">
            <div className="aspect-square">
              <img
                src={esteponaImages[2].url}
                alt={esteponaImages[2].alt[language]}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>

          <div className="relative overflow-hidden group">
            <div className="aspect-square">
              <img
                src={esteponaImages[3].url}
                alt={esteponaImages[3].alt[language]}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>

          <div className="relative overflow-hidden group">
            <div className="aspect-square">
              <img
                src={esteponaImages[4].url}
                alt={esteponaImages[4].alt[language]}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>

          {/* Bottom row: 2 wide images */}
          <div className="col-span-2 relative overflow-hidden group">
            <div className="aspect-video">
              <img
                src={esteponaImages[5].url}
                alt={esteponaImages[5].alt[language]}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-3 left-3 text-white opacity-0 group-hover:opacity-100 transition-opacity">
              <p className="text-xs font-light">{esteponaImages[5].alt[language]}</p>
            </div>
          </div>

          <div className="col-span-2 relative overflow-hidden group">
            <div className="aspect-video">
              <img
                src={esteponaImages[6].url}
                alt={esteponaImages[6].alt[language]}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-3 left-3 text-white opacity-0 group-hover:opacity-100 transition-opacity">
              <p className="text-xs font-light">{esteponaImages[6].alt[language]}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EsteponaSection;
